module.exports = __webpack_public_path__ + "frontend-assets/img/card-affinity.85c3cb6a.png";